import { MoneyMapCategory } from '@fruitful/types';
import { SPACE_COLOR_KEYS } from 'smoothie';

// Applies only to names entered in the money map editing inputs. Longer names
// can exist (they aren't limited elsewhere) and are displayed as-is.
export const MONEY_MAP_NAME_MAX_LENGTH = 50;

export const MoneyMapCategoryToColorMap = {
    [MoneyMapCategory.INCOME]: '$lemonLight',
    [MoneyMapCategory.BILLS]: '$waterLight',
    [MoneyMapCategory.SPEND]: '$leafLight',
    [MoneyMapCategory.GOALS]: '$petalLight',
    [MoneyMapCategory.OTHER_ACCOUNTS]: '$gray400',
};

// Maps MoneyMap categories to bank account colors.
export const MoneyMapCategoryToAccountColorMap = {
    [MoneyMapCategory.INCOME]: SPACE_COLOR_KEYS.BLUE,
    [MoneyMapCategory.BILLS]: SPACE_COLOR_KEYS.BLUE,
    [MoneyMapCategory.SPEND]: SPACE_COLOR_KEYS.GREEN,
    [MoneyMapCategory.GOALS]: SPACE_COLOR_KEYS.PEACH,
    [MoneyMapCategory.OTHER_ACCOUNTS]: SPACE_COLOR_KEYS.PEACH, // ENG-5965 As of 2026-03-20, this needs to string match exactly with a CardColor enum value
};

export const MoneyMapCategoryToLabelMap = {
    [MoneyMapCategory.INCOME]: 'Income',
    [MoneyMapCategory.BILLS]: 'Bills',
    [MoneyMapCategory.SPEND]: 'Spend',
    [MoneyMapCategory.GOALS]: 'Goals',
    [MoneyMapCategory.OTHER_ACCOUNTS]: 'Other accounts',
};
